import { HoneycombThemeBase } from '../types';
import { up } from './breakpoints/breakpoints';

export function makeGutterStyles(theme: HoneycombThemeBase) {
    return (properties: string | { name: string; coefficient?: number }[], coefficient = 1) => {
        const { keys, values, gutters } = theme.breakpoints;
        const propertiesArray = Array.isArray(properties) ? properties : [{ name: properties, coefficient }];
        return keys
            .map((breakpoint) => {
                const gutter = gutters[breakpoint] * theme.spacingUnit;
                const gutterStyles = propertiesArray
                    .map((prop) => {
                        return `${prop.name}: ${gutter * (prop.coefficient || coefficient)}px;`;
                    })
                    .join('\n');
                // We don't need a media query where the breakpoint value is zero.
                if (values[breakpoint] === 0) {
                    return gutterStyles;
                }
                return `${up(theme)(breakpoint)} {
                    ${gutterStyles}
                }`;
            })
            .join('\n');
    };
}
